module.exports = __webpack_public_path__ + "img/mobile-spectrum-NIST.a4390c2e.png";